import React from 'react';
import StockStatus from '../StockStatus/StockStatus';
import './ProductCard.css';

const ProductCard = ({ product, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(product);
    }
  };

  return (
    <div className="product-card" onClick={handleClick}>
      <div className="product-main">
        <div className="product-code">
          <strong>{product.codigo}</strong>
        </div>
        <div className="product-description">{product.descricao}</div>
      </div>
      <StockStatus 
        stock={product.estoque}
        minimum={product.minimo}
        unit={product.unidade}
      />
    </div>
  );
};

export default ProductCard;
